import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import defaultDash from './default';
import newOrder from './new-order';
import listPayments from './list-payments';
import listProcess from './list-process';
import archive from './archive';
import viewOrder from './view-order';
const Dashboards = ({ match }) => (
    localStorage.getItem('user_can').split(",").indexOf("menu-order") > -1 ?
        <div className="dashboard-wrapper">
            <Switch>
                <Redirect exact from={`${match.url}/`} to={`${match.url}/default`} />
                <Route path={`${match.url}/default`} component={defaultDash} />
                <Route path={`${match.url}/new-order`} component={newOrder} />
                <Route path={`${match.url}/list-payments`} component={listPayments} />
                <Route path={`${match.url}/list-process`} component={listProcess} />
                <Route path={`${match.url}/view-order/:orderId`} component={viewOrder} />
                <Route path={`${match.url}/archive/:customerMobile`} component={archive} />
                <Route path={`${match.url}/archive`} component={archive} />
                <Redirect to="/error" />
            </Switch>
        </div>
        : false
);
export default Dashboards;